import React from 'react';
import { useNavigate } from 'react-router-dom';

function CategoryFooter() {
  const navigate = useNavigate();

  // Category data with actual IDs from the API
  const categories = [
    {
      id: 4, // Mobile Cases category ID from API (using for first category)
      title: "Mobile Cases",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/582455613a25900b276c474b2237d75434d5e50f?placeholderIfAbsent=true&apiKey=eab1af0f511c4100b10b691a6db8263e",
      bgColor: "bg-amber-100"
    },
    {
      id: 5, // Frames category ID from API (using for Fridge magnets)
      title: "Fridge magnets",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/99368904690cf2f715f98ee877fce86189a73f40?placeholderIfAbsent=true&apiKey=eab1af0f511c4100b10b691a6db8263e",
      bgColor: "bg-orange-200"
    },
    {
      id: 2, // Name Pencils category ID from API (using for Desk Decorations)
      title: "Desk Decorations",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/a23d4db87a4191a01e0d0803bbcba24cfd5d386e?placeholderIfAbsent=true&apiKey=eab1af0f511c4100b10b691a6db8263e",
      bgColor: "bg-slate-200"
    }
  ];

  const handleCategoryClick = (categoryId) => {
    navigate(`/category/${categoryId}`);
  };

  const handleViewAllClick = () => {
    navigate('/products');
  };

  return (
    <footer className="mt-7 w-full bg-teal-800 max-md:max-w-full">
      <div className="w-full max-md:max-w-full">
        <div className="flex gap-5 max-md:flex-col">
          <div className="w-[42%] max-md:ml-0 max-md:w-full">
            <div className="grow -mt-1 max-md:mt-10 max-md:max-w-full">
              <div className="flex gap-5 max-md:flex-col">
                <div className="w-1/5 max-md:ml-0 max-md:w-full">
                  <img
                    src="https://api.builder.io/api/v1/image/assets/TEMP/aa91577649149a523215a910758a8ce78b087972?placeholderIfAbsent=true&apiKey=eab1af0f511c4100b10b691a6db8263e"
                    alt="Decorative element"
                    className="object-contain grow shrink-0 aspect-[0.33] w-[99px] max-md:mt-5"
                  />
                </div>
                <div className="ml-5 w-4/5 max-md:ml-0 max-md:w-full">
                  <div className="self-stretch my-auto text-white max-md:mt-10">
                    <h2 className="text-5xl font-semibold leading-[55px] max-md:text-4xl max-md:leading-10">
                      Top Picks for <br />
                      Custom Creations
                    </h2>
                    <p className="mt-4 mr-9 text-lg font-medium leading-6 max-md:mr-2.5">
                      Browse our most-loved categories and shop your next
                      favorite design.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* First Category Card */}
          <div className="ml-5 w-[16%] max-md:ml-0 max-md:w-full">
            <button
              onClick={() => handleCategoryClick(categories[0].id)}
              className="flex flex-col justify-center items-center px-4 mx-auto mt-16 bg-amber-100 rounded-lg h-[199px] shadow-[0px_5px_23px_rgba(0,0,0,0.1)] w-[199px] max-md:mt-10 hover:shadow-xl hover:scale-105 transition-all duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-yellow-300"
              aria-label={`Browse ${categories[0].title} category`}
            >
              <img
                src={categories[0].image}
                alt={categories[0].title}
                className="object-contain aspect-[0.91] w-[166px] transition-transform duration-200 group-hover:scale-110"
              />
            </button>
          </div>

          {/* Second Category Card with View All Button */}
          <div className="ml-5 w-[16%] max-md:ml-0 max-md:w-full">
            <div className="flex flex-col mt-2 text-lg leading-none max-md:mt-10">
              <button
                onClick={() => handleCategoryClick(categories[1].id)}
                className="px-7 py-3 font-bold bg-orange-200 rounded-lg h-[199px] shadow-[0px_5px_23px_rgba(0,0,0,0.1)] text-zinc-700 w-[199px] max-md:px-5 hover:shadow-xl hover:scale-105 transition-all duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-orange-300"
                aria-label={`Browse ${categories[1].title} category`}
              >
                <img
                  src={categories[1].image}
                  alt={categories[1].title}
                  className="object-contain w-36 aspect-square transition-transform duration-200 hover:scale-110"
                />
                <h3 className="mt-2.5 ml-3 max-md:mr-2.5 max-md:ml-2.5">
                  {categories[1].title}
                </h3>
              </button>
              <button
                onClick={handleViewAllClick}
                className="flex flex-col justify-center items-start self-center px-4 py-2.5 mt-3.5 max-w-full font-medium text-black bg-yellow-500 rounded-[34px] w-[122px] max-md:pr-5 hover:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-yellow-300 transition-colors duration-200 cursor-pointer"
                aria-label="View all categories"
              >
                View all
              </button>
            </div>
          </div>

          {/* Third Category Card */}
          <div className="ml-5 w-[26%] max-md:ml-0 max-md:w-full">
            <div className="flex gap-10 text-lg font-bold leading-none text-zinc-700 max-md:mt-10">
              <button
                onClick={() => handleCategoryClick(categories[2].id)}
                className="px-6 pt-1.5 pb-4 my-auto rounded-lg bg-slate-200 h-[199px] shadow-[0px_5px_23px_rgba(0,0,0,0.1)] w-[199px] max-md:px-5 hover:shadow-xl hover:scale-105 transition-all duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-slate-300"
                aria-label={`Browse ${categories[2].title} category`}
              >
                <img
                  src={categories[2].image}
                  alt={categories[2].title}
                  className="object-contain aspect-[1.01] w-[153px] transition-transform duration-200 hover:scale-110"
                />
                <h3 className="max-md:mr-1.5">
                  {categories[2].title}
                </h3>
              </button>
              <img
                src="https://api.builder.io/api/v1/image/assets/TEMP/c05e753c04343853cb0ad9ccb6de3f9e055a1657?placeholderIfAbsent=true&apiKey=eab1af0f511c4100b10b691a6db8263e"
                alt="Decorative element"
                className="object-contain shrink-0 aspect-[0.28] w-[83px]"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default CategoryFooter;
